import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

/**
 *  Service de gestion des informations bancaires
 */
@Injectable()
export class InfrumService extends BehaviorSubject<any[]> {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    super([]);
    this.w_baseUrl = this.s_global.pathAPI + "/infrum";
  }

  /** Data suivante */
  public proc_next(data) {
    if (data != null) super.next(data);
    else super.next([]);
  }

  /**
   * Fonction de recuperation de tous les infrum
   * Retour : json avec la liste de toutes les infrum
   */
  public proc_getAll(): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/getall`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation d'un infrum de l'utilisateur
   * Retour : json avec l'infrum de l'utilisateur
   */
  public proc_findInfoBancByToken(): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getInfrumByToken`,
      "",
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction d'ecriture des informations bancaires en BDD : création d'un objet Infrum puis ajout en BDD grâce à la fonction add
   * Parametres : BIC et IBAN de l'utilisateur
   */
  public proc_addInfrumByToken(bic: string, iban: string): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/addInfrumByToken`,
      JSON.stringify({ bic: bic, iban: iban }),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation des informations necessaires pour generer le PDF Mandat
   * Retour : json avec l'infrum de l'utilisateur et de Amplitex
   */
  public proc_findInfosMandat(): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getInfosMandat`,
      "",
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation des informations necessaires pour l'affichage des bonnes cartes de la page PageInfoBan
   * Retour : json avec etat actuel de l'infrum de l'utilisateur
   */
  public proc_findStateInfrum(): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getStateInfrum`,
      "",
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction du dernier infrum actif de l'utilisateur
   * Retour : json avec dernier infrum actif de l'utilisateur
   */
  public proc_findLastActif(): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/getLastActif`,
      "",
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de recuperation de tous les infrums avec raisonsociletiers
   * Retour : json avec la liste de tous les infrums avec raisonsociletiers
   */
  public proc_getJsonInfrum(): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/getJsonInfrum`,
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de suppression d'un infrum dans la BDD
   * Parametres : infrum a supprimer
   */
  public proc_delete(infrum: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/delete`,
      JSON.stringify(infrum),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction d'ajout d'un infrum dans la BDD
   * Parametres : infrum a ajouter
   *
   */
  public proc_add(infrum: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/add`,
      JSON.stringify(infrum),
      this.s_appsettings.proc_getHeaders()
    );
  }

  /**
   * Fonction de mise a jour d'un infrum dans la BDD
   * Parametres : infrum a modifier
   *
   */
  public proc_update(infrum: any): Observable<any> {
    return this.http.post(
      `${this.w_baseUrl}/update`,
      JSON.stringify(infrum),
      this.s_appsettings.proc_getHeaders()
    );
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/infrum.service.ts